import type { FC, SVGProps } from "react";

const IconCustomizedPackages: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M9 21V6C9 5.73478 8.89464 5.48043 8.70711 5.29289C8.51957 5.10536 8.26522 5 8 5H3C2.46957 5 1.96086 5.21071 1.58579 5.58579C1.21071 5.96086 1 6.46957 1 7V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V14C17 13.7348 16.8946 13.4804 16.7071 13.2929C16.5196 13.1054 16.2652 13 16 13H1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M20 1H14C13.4477 1 13 1.44772 13 2V8C13 8.55228 13.4477 9 14 9H20C20.5523 9 21 8.55228 21 8V2C21 1.44772 20.5523 1 20 1Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconCustomizedPackages;
